/* https://flatsomexperts.com/article/how-to-make-a-text-fade-rotator/ */
(function ($) {
    $.fn.extend({
        textrotator: function (options) {
            var defaults = {
                fadeSpeed: 500,
                pauseSpeed: 100,
                child: null,
                started: 0
            };

            var options = $.extend(defaults, options);
            return this.each(function () {
                var o = options;
                var obj = $(this);
                var items = $(obj.children(), obj);
                if (o.started != 0) {
                    items.each(function () {
                        $(this).hide();
                    });
                }
                o.started = 1;
                var next = !o.child ? $(obj).children(':first') : o.child;

                $(next).fadeIn(o.fadeSpeed, function () {
                    $(next).delay(o.pauseSpeed).fadeOut(o.fadeSpeed, function () {
                        var next = $(this).next();
                        if (next.length == 0) {
                            next = $(obj).children(':first');
                        }
                        $(obj).textrotator({child: next, fadeSpeed: o.fadeSpeed, pauseSpeed: o.pauseSpeed});
                    })
                });
            });
        }
    });
})($);
